import { render, staticRenderFns } from "./UkrTreasuresCreate.vue?vue&type=template&id=2c85c78e&scoped=true"
import script from "./UkrTreasuresCreate.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85c78e",
  null
  
)

export default component.exports